import {
  useEffect,
  useState,
  useCallback,
} from "react";

import { BrandingContext } from "../contexts/BrandingContext";
import { clientApi } from "../api/tenantApi";

export const BrandingProvider = ({
  children,
}) => {
  // =========================
  // STATE
  // =========================
  const [logoUrl, setLogoUrl] = useState("");
  const [authVersion, setAuthVersion] = useState(0);

  // =========================
  // FETCH LOGO
  // =========================
  const loadBranding = useCallback(async () => {
    // console.log("loadBranding called");
    try {
      const response =
        await clientApi.getLogo();

      const logo =
        response?.data ||
        response?.data?.data ||
        response?.data?.data?.data;

      if (logo) {
        // cache busting for updated logo
        setLogoUrl(
          `${logo}?v=${Date.now()}`
        );
      } else {
        setLogoUrl("");
      }
    } catch (error) {
      console.error(
        "Failed to load branding:",
        error
      );
    }
  }, []);

  // =========================
  // AUTO REFRESH TRIGGERS
  // =========================
  useEffect(() => {
    loadBranding();
  }, [authVersion, loadBranding]);

  // =========================
  // LOGIN HANDLER (CALL THIS AFTER LOGIN)
  // =========================
  const handleContextLogin = () => {
    setAuthVersion((prev) => prev + 1);
  };

  // =========================
  // LOGOUT HANDLER
  // =========================
  const handleContextLogout = () => {
    setLogoUrl("");
    setAuthVersion((prev) => prev + 1);
  };

  // =========================
  // MANUAL REFRESH (optional use in settings page)
  // =========================
  const refreshBranding = async () => {
    // console.log("refreshBranding called");
    await loadBranding();
  };

  // =========================
  // CONTEXT VALUE
  // =========================
  const value = {
    logoUrl,

    handleContextLogin,
    handleContextLogout,

    refreshBranding,
  };

  return (
    <BrandingContext.Provider
      value={value}
    >
      {children}
    </BrandingContext.Provider>
  );
};